import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';
import { CountrysideZoneEditionPayload, EditedCountrysideZoneData } from './countryside-zone-edition.types';

export async function updateCountrysideZoneService({ query: rawQuery, body }: CountrysideZoneEditionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put<EditedCountrysideZoneData>(ENDPOINT.COUNTRYSIDES_ZONES, {
    query,
    body,
  });

  return {
    response,
    summary: data,
  };
}
